// extracted by mini-css-extract-plugin
export default {"mainContainer":"PreviewSection_mainContainer__4kvY0","mainContent":"PreviewSection_mainContent__b1UMN","heading":"PreviewSection_heading__M+UR5"};